import Cancel from 'axios/lib/cancel/Cancel';

export var isCancelled = function isCancelled(err) {
  if (err.error instanceof Cancel) {
    return true;
  }
  return false;
};
//# sourceMappingURL=cancelled.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-api/lib/cancelled.js
// module id = 1075
// module chunks = 0